export enum AgencyStatusAction {
  ACTIVATE = 'ACTIVATE',
  REACTIVATE = 'REACTIVATE',
  REVOKE = 'REVOKE',
}
